import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Lock',
      title: 'SSL Encrypted',
      description: '256-bit encryption protects your data',
      color: 'text-success'
    },
    {
      icon: 'Shield',
      title: 'PCI Compliant',
      description: 'Payment Card Industry certified',
      color: 'text-primary'
    },
    {
      icon: 'ShieldCheck',
      title: 'Fraud Protection',
      description: 'Advanced fraud detection system',
      color: 'text-accent'
    },
    {
      icon: 'CheckCircle',
      title: 'Secure Payment',
      description: 'Your payment details are never stored',
      color: 'text-success'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-success/5 via-primary/5 to-accent/5 rounded-xl border border-border p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="ShieldCheck" size={24} className="text-success" />
        <h3 className="text-lg font-heading font-bold text-foreground">
          Your Payment is Secure
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-full bg-card border border-border flex items-center justify-center">
                <Icon name={feature?.icon} size={18} className={feature?.color} />
              </div>
            </div>
            <div>
              <p className="font-medium text-foreground text-sm">{feature?.title}</p>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-center gap-6 flex-wrap">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="CreditCard" size={16} />
            <span>Visa, Mastercard, Amex</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Smartphone" size={16} />
            <span>UPI & Wallets</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Building2" size={16} />
            <span>Net Banking</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;